<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="detail-header">
          <span class="header-title">机房信息</span>
          <div class="arrow-pic"></div>
        </div>
        <el-divider></el-divider>
        <div class="config-header">
          <div class="config-header-title">当前机房运行情况</div>
          <div class="room-content">
            <div class="item">
              <div class="item-left img1"></div>
              <div class="item-right">
                <div>温度</div>
                <div class="font-blue">{{ roomData.temperature }}℃</div>
              </div>
            </div>
            <div class="item">
              <div class="item-left img2"></div>
              <div class="item-right">
                <div>湿度</div>
                <div class="font-blue">{{ roomData.moisture }}%</div>
              </div>
            </div>
            <div class="item">
              <div class="item-left img3"></div>
              <div class="item-right">
                <div>漏水</div>
                <div class="font-blue2">{{ roomData.dripping }}</div>
              </div>
            </div>
            <div class="item">
              <div class="item-left img4"></div>
              <div class="item-right">
                <div>烟雾</div>
                <div class="font-blue2">{{ roomData.smog }}</div>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-header>
      <zj-layout-main
        style="padding-top: 0; overflow-y: auto"
        :loading="loading"
      >
        <div class="config-header">
          <div class="config-header-title">用电量统计</div>
          <div class="config-content" style="height: 100%">
            <el-form
              class="zj-search-form"
              ref="form"
              :model="form"
              :label-width="labelWidth"
            >
              <el-form-item label="统计时间" prop="date">
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 60rem; float: left"
                  unlink-panels
                  :clearable="false"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label>
                <el-button @click="onSearch" style="float: left"
                  >搜 索</el-button
                >
              </el-form-item>
            </el-form>
            <div class="analysis_chart">
              <div style="width: 100%; height: 100%">
                总能耗{{ totalNum }}KWH
                <LineEchart3
                  title=""
                  xAxisName="日期"
                  yAxisName="KWH"
                  :chartData="analysisData"
                ></LineEchart3>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import {
  getEquipmentCode,
  listEquipment,
  listAggregationDay,
} from "@/api/src/equipment";

export default {
  name: "RoomView",
  componentName: "RoomView",

  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      loading: false,

      //预警日志
      logList: [],
      //设备信息
      roomEquipmentList: [],
      roomData: {
        temperature: 0,
        moisture: 0,
        dripping: "正常",
        smog: "正常",
      },
      date: [
        new Date(new Date() - 7 * 24 * 60 * 60 * 1000),
        new Date(new Date() - 1 * 24 * 60 * 60 * 1000),
      ],
      totalNum: 0, //总能耗
      analysisData: {
        days: [],
        data: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date().getTime() - 3600 * 1000 * 24;
        },
      },
    };
  },
  methods: {
    // 获取设备code
    init() {
      getEquipmentCode("roomEquipment").then((response) => {
        this.code = response.data;
        this.getList();
      });
    },
    // 查询
    getList() {
      this.loading = true;

      listEquipment({ categoryCode: this.code })
        .then((response) => {
          this.roomEquipmentList = [];
          let list = response.rows;
          if (list.length > 0) {
            list.forEach((item) => {
              if (item.extra2) {
                const tempData = JSON.parse(list[0].extra2);
                this.roomData = {};
                tempData.forEach((item) => {
                  switch (item.key) {
                    case "温度":
                      this.roomData.temperature = item.value || 0;
                      break;
                    case "湿度":
                      this.roomData.moisture = item.value || 0;
                      break;
                    case "漏水":
                      this.roomData.dripping =
                        item.value == "true" ? "异常" : "正常" || "正常";
                      break;
                    case "烟雾":
                      this.roomData.smog =
                        item.value == "true" ? "异常" : "正常" || "正常";
                      break;
                    default:
                      break;
                  }
                });
              }
            });
          }
          this.onSearch();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onSearch() {
      this.loading = true;
      const searchInfo = {
        startTs:
          this.date == null ? "0001-01-01T00:00:00" : this.date[0].getTime(),
        endTs:
          this.date == null ? "0001-01-01T00:00:00" : this.date[1].getTime(),
        pageSize: 10000,
        categoryCode: this.code,
        countType: "有功电度",
      };

      listAggregationDay(searchInfo)
        .then((response) => {
          let days = [],
            data = [],
            totalNum = 0;

          response.data.forEach((item) => {
            days.push(item.statDay);
            data.push(item.statCount.toFixed(2));
            totalNum += item.statCount; //计算总能耗
          });
          this.analysisData = { days: days, data: data };
          this.totalNum = totalNum.toFixed(2);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.init();
    this.logInfo.ActionName = "智慧机房数据统计查看";
    this.logInfo.LogMessage = "智慧机房数据统计查看";
    this.logInfo.ModuleName = "智能控制";
    this.logInfo.PageName = "智慧机房数据统计查看";
    this.addOperationLog();
  },
  beforeDestroy() {},
  destroyed() {},
  controller: "UI",
  action: "RoomView",
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
